export { default as Img200 } from './processed/200/Westworld.jpg';
export { default as Img400 } from './processed/400/Westworld.jpg';
export { default as Imgthumb } from './processed/thumb/Westworld.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Westworld.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Westworld.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      76,
      148,
      164
    ],
    "_population": 1,
    "_hsl": [
      0.5303030303030303,
      0.36666666666666675,
      0.47058823529411764
    ]
  },
  "LightVibrant": {
    "_rgb": [
      196,
      228,
      244
    ],
    "_population": 5,
    "_hsl": [
      0.5555555555555556,
      0.6857142857142862,
      0.8627450980392157
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      36,
      76,
      96
    ],
    "_population": 10,
    "_hsl": [
      0.5555555555555556,
      0.4545454545454546,
      0.2588235294117647
    ]
  },
  "Muted": {
    "_rgb": [
      96,
      130,
      149
    ],
    "_population": 234,
    "_hsl": [
      0.559748427672956,
      0.21632653061224494,
      0.4803921568627451
    ]
  },
  "LightMuted": {
    "_rgb": [
      178,
      208,
      217
    ],
    "_population": 2318,
    "_hsl": [
      0.5384615384615384,
      0.33913043478260874,
      0.7745098039215685
    ]
  },
  "DarkMuted": {
    "_rgb": [
      39,
      61,
      69
    ],
    "_population": 3367,
    "_hsl": [
      0.5444444444444444,
      0.27777777777777773,
      0.21176470588235294
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Westworld.js